import { render, staticRenderFns } from "./bindPatient.vue?vue&type=template&id=5a07582c&scoped=true&"
import script from "./bindPatient.vue?vue&type=script&lang=js&"
export * from "./bindPatient.vue?vue&type=script&lang=js&"
import style0 from "./bindPatient.vue?vue&type=style&index=0&id=5a07582c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a07582c",
  null
  
)

export default component.exports